import React from 'react';
import StepperComponent from 'app/Components/Shared/StepperComponent/StepperComponent';
import {stepEnum} from '../Constants/debtPaymentEnum';

const DEBT_PAYMENT_STEPS = [
  {key: stepEnum.BANSELECT, label: 'בחירת חשבון'},
  {key: stepEnum.SELECTAMOUNT, label: 'סכום לתשלום'},
  {key: 'payment', label: 'תשלום'},
];

const isPaymentStep = (step) => step === stepEnum.SELECTPAYMENTTYPE || step === stepEnum.CREDITCARD;

const getActiveStepKey = (currentStep) => {
  if (isPaymentStep(currentStep)) return 'payment';
  return currentStep;
};

const DebtPaymentStepper = ({currentStep}) => {
  const showStepper = [stepEnum.SELECTAMOUNT, stepEnum.SELECTPAYMENTTYPE, stepEnum.CREDITCARD].includes(currentStep);

  if (!showStepper) return null;

  return <StepperComponent steps={DEBT_PAYMENT_STEPS} activeStepKey={getActiveStepKey(currentStep)} maxWidth={440} />;
};

export default DebtPaymentStepper;
